/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSupportPagedList } from '../../models/auth-support-paged-list';
import { SortDirection } from '../../models/sort-direction';

export interface SearchAuthSupportsOfSubscription$Any$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * TYPE : the auth support type
 *   * VALUE : the auth support value
 *   * STATE : the auth support state
 *   * CREATION_DATE : the auth support creation date
 *   * VALIDITY_START
 *   * VALIDITY_END
 *   * SUBSERVICE_NAME
 *   * SUBSCRIPTION_NAME
 *   * PlATE_NUMBER
 *   * PARC_NUMBER
 *   * REQUEST_KM
 */
  sortFieldName?: 'TYPE' | 'VALUE' | 'STATE' | 'CREATION_DATE' | 'VALIDITY_START' | 'VALIDITY_END' | 'SUBSERVICE_NAME' | 'SUBSCRIPTION_NAME' | 'PlATE_NUMBER' | 'PARC_NUMBER' | 'REQUEST_KM';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The search text to filter API
 */
  search?: string;
  
    /**
     * Body for search auth support
     */
    body?: any
}

export function searchAuthSupportsOfSubscription$Any(http: HttpClient, rootUrl: string, params: SearchAuthSupportsOfSubscription$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchAuthSupportsOfSubscription$Any.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthSupportPagedList>;
    })
  );
}

searchAuthSupportsOfSubscription$Any.PATH = '/subscriptions/{uid}/auth-supports/search';
